import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { GenericRadioTextFilter } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextFilter';
import type {
  ContainOperation,
  NotContainOperation,
  RadioTextFilterValueType,
} from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { RadioTextFilterOperation } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/KeywordLabelFormatter';

export type KeywordResponseFilterValue = ContainOperation | NotContainOperation | undefined;

export function KeywordFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<RadioTextFilterValueType>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.Keyword);
  const { label1, label2 } = getLabels(currentValue);
  const placeholders = {
    [RadioTextFilterOperation.CONTAINS]: 'e.g. order',
    [RadioTextFilterOperation.NOT_CONTAINS]: 'e.g. order',
  };
  return (
    <GenericRadioTextFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      placeholders={placeholders}
      options={[RadioTextFilterOperation.CONTAINS, RadioTextFilterOperation.NOT_CONTAINS]}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      label1={label1}
      label2={label2}
    />
  );
}
